// extracted by mini-css-extract-plugin
export default {"card":"FeatureManagement_card__6XXlN","collapse":"FeatureManagement_collapse__p4KM3"};